import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted, onBeforeUnmount, nextTick } from 'vue'
  import type { PropType } from 'vue'
  import eventBus from '@/main'
  import useIcons from '@/composables/useIcons'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'CustomProgressBar',
  props: {
    divisions: {
      type: Number,
      default: 1,
    },
    fillDivisions: {
      type: Array as PropType<boolean[]>,
      default: () => [],
    },
    startAt: {
      type: Number,
      default: -10,
    },
    hasCertLogo: {
      type: Boolean,
      default: true,
    },
  },
  setup(__props) {

const props = __props;

  
  const { logoMarker, certLogo } = useIcons()
  const progressThumbPosition = ref(0)
  const showThumb = ref(true)
  const resizeObserver = ref<ResizeObserver | null>(null)

  const calculateProgressThumbPosition = () => {
    progressThumbPosition.value = props.startAt
    nextTick(() => {
      const markers = eventBus.$el.querySelectorAll('.marker.fill')
      markers?.forEach((el) => {
        progressThumbPosition.value += (el as HTMLSpanElement).offsetWidth
      })
      progressThumbPosition.value--
    })
  }

  onMounted(() => {
    nextTick(() => {
      const container = eventBus.$el?.querySelector('.custom-progress-bar')
      if (container instanceof Element) {
        resizeObserver.value = new ResizeObserver(() => {
          showThumb.value = false
          requestAnimationFrame(() => {
            calculateProgressThumbPosition()
            showThumb.value = true
          })
        })
        resizeObserver.value.observe(container)
      }
      calculateProgressThumbPosition()
    })
  })

  onBeforeUnmount(() => {
    if (resizeObserver.value) {
      resizeObserver.value.disconnect()
    }
  })

return { __sfc: true,props, logoMarker, certLogo, progressThumbPosition, showThumb, resizeObserver, calculateProgressThumbPosition, ref, onMounted, onBeforeUnmount, nextTick, eventBus, useIcons }
}

})